import { useState } from "react";
import { getAppliedCourseSearchTerm } from "@/components/lms/lmsCoursesShared";

interface Params<TTab extends string, TFilters> {
  initialFilters: TFilters;
  initialTab: TTab;
}

export function useLmsCourseListControls<TTab extends string, TFilters>({
  initialFilters,
  initialTab,
}: Params<TTab, TFilters>) {
  const [searchInput, setSearchInput] = useState("");
  const [activeTab, setActiveTab] = useState<TTab>(initialTab);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [filters, setFilters] = useState<TFilters>(initialFilters);

  return {
    activeTab,
    appliedSearchTerm: getAppliedCourseSearchTerm(searchInput),
    filters,
    isFiltersOpen,
    searchInput,
    setActiveTab,
    setFilters,
    setIsFiltersOpen,
    setSearchInput,
  };
}
